<template>
  <div>
    <div class="card">
      <div class="card-content">
        <p
          class="subtitle is-4"
        >Look at that! Since {{ paddedHours }}:{{ paddedMinutes }} you have earned</p>
        <h3 class="title is-1 has-text-centered">{{ currentCount.toLocaleString() }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '../utils/helpers';
export default {
	props: ['currentCount', 'startHours', 'startMinutes'],
	computed: {
		paddedHours: function() {
			return helpers.pad(this.startHours, 2);
		},
		paddedMinutes: function() {
			return helpers.pad(this.startMinutes, 2);
		},
	},
};
</script>

<style scoped>
</style>
